<template>
  <v-alert :type="type" border="left" text v-bind="$attrs" icon="mdi-alert-circle-outline">
    <ressource :code="code" :hide-if-empty="hideIfEmpty" class="black--text"></ressource>
  </v-alert>
</template>

<script>
export default {
  props: {
    code: {
      type: String,
      default: ""
    },
    hideIfEmpty: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "info"
    }
  }
}
</script>

<style>
</style>